import { Goal, GoalImpactLevel } from '@griply/types';
import { useUpdateGoal } from 'features/goals';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ThunderLightning16 } from 'shared/assets/icons';
import { ImpactPickerMenu } from 'shared/components/ui/impact-picker-menu';
import { useOpenMenu } from 'shared/hooks/use-open-menu';

import { MetaRow } from './meta-row';

export type ImpactPickerRowProps = {
  goal: Goal;
  isEditable: boolean;
};

export const ImpactPickerRow: React.FC<ImpactPickerRowProps> = ({
  goal,
  isEditable,
}) => {
  const { t } = useTranslation();
  const { submit: updateGoal } = useUpdateGoal();
  const impactRef = useRef<HTMLSpanElement>(null);
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();

  const impactLabelMap: Record<GoalImpactLevel, string> = {
    [GoalImpactLevel.High]: t('goal.impact.options.high.label'),
    [GoalImpactLevel.Medium]: t('goal.impact.options.medium.label'),
    [GoalImpactLevel.Low]: t('goal.impact.options.low.label'),
  };

  const onImpactChange = (value: GoalImpactLevel | null) => {
    updateGoal({ id: goal.id, impact: value });
    closeMenu();
  };

  return (
    <>
      <MetaRow
        ref={impactRef}
        icon={ThunderLightning16}
        label={t('forms.goal.fields.impact.label')}
        isClickable={isEditable}
        isPlaceholder={!goal.impact}
        onClick={openMenu}
      >
        {goal.impact
          ? impactLabelMap[goal.impact]
          : t('forms.goal.fields.impact.placeholder')}
      </MetaRow>

      {menuOpen && (
        <ImpactPickerMenu
          referenceElement={impactRef}
          value={goal.impact ?? null}
          onChange={onImpactChange}
          onClose={closeMenu}
        />
      )}
    </>
  );
};
